"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _default = exports["default"] = /*#__PURE__*/function () {
  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
  }
  return (0, _createClass2["default"])(_default, null, [{
    key: "addEventListenerMultiple",
    value:
    /**
     * 여러개의 이벤트를 바인딩한다.
     * @param {HTMLElement} target
     * @param {Array<string> | string} eventTypes string 인 경우 space split
     * @param {function} eventHandler
     * @param {AddEventListenerOptions?} option
     */
    function addEventListenerMultiple(target, eventTypes, eventHandler, option) {
      if (!(target instanceof HTMLElement)) {
        return;
      }
      if (typeof eventTypes === 'string') {
        eventTypes.split(' ').forEach(function (eventType) {
          return target.addEventListener(eventType, eventHandler, option);
        });
      } else if (eventTypes instanceof Array) {
        eventTypes.forEach(function (eventType) {
          return target.addEventListener(eventType, eventHandler, option);
        });
      }
    }
  }]);
}();